<template>
	<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-info">
		<circle cx="12.5" cy="12" r="9" stroke="black" stroke-width="2"/>
		<path d="M13 7.5C13 7.77614 12.7761 8 12.5 8C12.2239 8 12 7.77614 12 7.5C12 7.22386 12.2239 7 12.5 7C12.7761 7 13 7.22386 13 7.5Z"
			  fill="black" stroke="black"/>
		<path d="M12.5 17V10" stroke="black" stroke-width="2"/>
	</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.icon-info {
  display: block;
}
</style>